const SendDataService = {
  SendData: async function(data,sendCreateFlag) {
    const url = `${process.env.REACT_APP_API}/docs/send?html=`+sendCreateFlag; 
    const jwtToken = localStorage.getItem('JWtToken');
    return await fetch(url, {
      mode: 'cors',
      method: 'POST',
      body: data,
      headers: {'Authorization': `Bearer ${jwtToken}` },
     
      })
      .then((responce) => {
        return responce.json()
    }).then(data => {
        //console.log(data);
        return data;
    })
    .catch((err) => {
         console.log("error"+err.message);
         return err.message;
      });
}
     
}
export default SendDataService;
